import { useState } from 'react';

/**
 * Custom hook for managing dashboard filters
 */
export const useFilters = () => {
    const [filters, setFilters] = useState({
        property_id: '',
        city: '',
        area: '',
        rooms: '',
        size: '',
        floor: '',
        status: '',
        has_tour: false
    });

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const clearFilters = () => {
        setFilters({
            property_id: '',
            city: '',
            area: '',
            rooms: '',
            size: '',
            floor: '',
            status: '',
            has_tour: false
        });
    };

    const hasActiveFilters = Object.values(filters).some(value => value !== '');

    return {
        filters,
        handleFilterChange,
        clearFilters,
        hasActiveFilters
    };
};
